export default __webpack_public_path__ + "images/1B.27b6cba.png";